import CustomText from "../../atomic/CustomText";

interface ColumnDefinition {
  key: string;
  label: string;
  accessor: (row: any) => any;
  highlight?: boolean;
  formatter?: (value: any) => string;
}

interface SearchResultsTableProps {
  columns: ColumnDefinition[];
  data: any[];
  onRowClick?: (row: any) => void;
  searchQuery: string;
  highlightMatchingText: (text: string, query: string) => JSX.Element;
}

function SearchResultsTable({
  columns,
  data,
  onRowClick,
  searchQuery,
  highlightMatchingText,
}: Readonly<SearchResultsTableProps>): JSX.Element {
  return (
    <div className="overflow-x-auto">
      <table className="w-full">
        <thead>
          <tr>
            {columns.map((column) => (
              <th
                key={column.key}
                className="bg-[#f9fafb] border-b border-[#eaecf0] px-4 py-4 text-left"
              >
                <CustomText
                  text={column.label}
                  fontWeight="font-medium"
                  fontSize="text-xs"
                  className="text-[#475467]"
                />
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.slice(0, 5).map((row: any, rowIndex: number) => (
            <tr
              key={row.id || rowIndex}
              onClick={() => onRowClick?.(row)}
              className="cursor-pointer hover:bg-[rgba(0,0,0,0.05)] border-b border-[#eaecf0]"
            >
              {columns.map((column) => {
                const rawValue = column.accessor(row);
                const formattedValue = column.formatter
                  ? column.formatter(rawValue)
                  : rawValue;
                const displayValue = formattedValue ?? "---";

                return (
                  <td key={column.key} className="px-4 py-4">
                    {column.highlight && searchQuery ? (
                      <div className="text-sm text-[#475467]">
                        {highlightMatchingText(
                          typeof displayValue === "string"
                            ? displayValue
                            : String(displayValue),
                          searchQuery
                        )}
                      </div>
                    ) : (
                      <CustomText
                        text={
                          typeof displayValue === "string"
                            ? displayValue
                            : String(displayValue)
                        }
                        fontWeight="font-normal"
                        fontSize="text-sm"
                        className="text-[#475467]"
                      />
                    )}
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default SearchResultsTable;

